import React from 'react'

class Hexagons extends React.Component {
  render() {
    return (
      <svg width="100%" viewBox="0 0 837 1045">
        <g fill="none">

          <path
            stroke="#2196f3"
            strokeWidth="5"
            d="M353,9 L626.664028,170 L626.664028,487 L353,642 L79.3359724,487 L79.3359724,170 L353,9 Z"
          />

          <path
            stroke="#f44336"
            strokeWidth="5"
            d="M78.5,529 L147,569.186414 L147,648.311216 L78.5,687 L10,648.311216 L10,569.186414 L78.5,529 Z"
          />

          <path
            stroke="#9c27b0"
            strokeWidth="5"
            d="M773,186 L827,217.538705 L827,279.636651 L773,310 L719,279.636651 L719,217.538705 L773,186 Z"
          />

          <path
            stroke="#ff9800"
            strokeWidth="5"
            d="M639,529 L773,607.846761 L773,763.091627 L639,839 L505,763.091627 L505,607.846761 L639,529 Z"
          />

          <path
            stroke="#4caf50"
            strokeWidth="5"
            d="M281,801 L383,861.025276 L383,979.21169 L281,1037 L179,979.21169 L179,861.025276 L281,801 Z"
          />

        </g>
      </svg>
    )
  }
}

export default Hexagons


// WEBPACK FOOTER //
// ./src/components/hexagons.js